import { PYLON_WIDGET_URL } from './constants';

/**
 * Dynamically loads the Pylon widget script
 * @returns Promise that resolves when script is loaded, rejects on error
 */
export const loadPylonScript = (): Promise<void> => {
  return new Promise((resolve, reject) => {
    // Check if Pylon is already loaded
    if (window.Pylon) {
      resolve();
      return;
    }

    // Check if script tag already exists
    const existingScript = document.querySelector(
      `script[src="${PYLON_WIDGET_URL}"]`
    );
    if (existingScript) {
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = PYLON_WIDGET_URL;
    script.crossOrigin = 'anonymous';

    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Failed to load Pylon widget'));

    document.head.appendChild(script);
  });
};
